export default {
  methods: {
    formatDate (dateTimeString) {
      if (!dateTimeString) {
        return null
      }
      const date = new Date(Date.parse(dateTimeString))
      return date.toLocaleDateString()
    },
    formatPublishDate (dateTimeString) {
      if (!dateTimeString) {
        return null
      }
      const date = new Date(Date.parse(dateTimeString))
      const month = date.toLocaleString('default', { month: 'short' })
      return month + ' ' + date.getFullYear()
    }
  }
}
